import type { PreviewModalContent } from "./preview-modal.type";

import { useSetAtom } from "jotai";

import { previewModalAtom } from "./preview-modal.state";

export const usePreviewModal = () => {
  const setPreviewModal = useSetAtom(previewModalAtom);

  const openPreviewModal = (content: PreviewModalContent) => {
    setPreviewModal({ visible: true, ...content });
  };

  const closePreviewModal = () => {
    setPreviewModal({ visible: false });
  };

  return {
    openPreviewModal,
    closePreviewModal,
  };
};
